export const SERVICE_NAME = 'P-man';
export const REGISTER_FORM_URL = 'https://forms.office.com/r/nCwdYQ7nc8';
// export const REGISTER_FORM_URL = 'https://forms.office.com/r/bEgK9rQvtG';

export const CONTACT_FORM_URL = 'https://forms.office.com/pages/responsepage.aspx?id=vP34RyYFZ0mfFfJIcFyligrOxYMBfrJHlhwmbLc8vsBUOUJOSEJKTUNGTzRRRFVSMEU1VzVPTDVIWS4u&route=shorturl';
